'use client';

import React from 'react';
import cn from './style.module.scss';

interface AlGhadeerWrapperProps {
  children: React.ReactNode;
}

export default function AlGhadeerWrapper({ children }: AlGhadeerWrapperProps) {
  return <main className={cn.alGhadeerWrapper}>{children}</main>;
}
